import { environment } from 'src/environments/environment';
import { Component, OnInit, Input, HostListener } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { EncrdecrService } from '../Auth/encrdecr.service';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-login-left-banner',
  templateUrl: './login-left-banner.component.html',
  styleUrls: ['./login-left-banner.component.scss']
})
export class LoginLeftBannerComponent implements OnInit {
  CompanyLogo: any;
  UserType: any;
  companyurlbase64: any;
  logoimage: string;
  LogoInterval: any;
  constructor(
    public sanitizer: DomSanitizer,
    private EncrdecrService: EncrdecrService
  ) {}
  IsOptimoney: boolean = false;
  IsMobile: boolean = false;
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.SetViewPort(event.target.innerWidth);
  }
  SetViewPort(w) {
    if (w <= 767) {
      this.IsMobile = true;
    } else {
      this.IsMobile = false;
    }
  }
  ngOnInit() {
    debugger;
    this.SetViewPort(window.innerWidth);
    this.companyurlbase64 = sessionStorage.getItem('lkighty445dh==');

    if (environment.IsOptimoney) {
      this.IsOptimoney = true;
    } else {
      debugger;
      if (this.companyurlbase64 != '' && this.companyurlbase64 != null) {
        this.CompanyLogo = 'data:image/jpg;base64,' + this.companyurlbase64;
      } else {
        if (this.IsMobile || !this.IsMobile) {
          this.logoimage = sessionStorage.getItem('lkighty445dh==');
          this.LogoInterval = setInterval(() => {
            console.log('INSIDE INTERVAL');
            if (this.logoimage == '' || isNullOrUndefined(this.logoimage)) {
              console.log('STILL INSIDE INTERVAL');
              this.logoimage = sessionStorage.getItem('lkighty445dh==');
              sessionStorage.getItem('ihjt45h45=p');
              sessionStorage.getItem('L2D3506kIHSk3E0');
              this.CompanyLogo = this.sanitizer.bypassSecurityTrustResourceUrl(
                'data:image/jpg;base64,' + this.logoimage
              );
            } else {
              console.log('ENDED INTERVAL');
              clearInterval(this.LogoInterval);
            }
          }, 1000);
        }
      }

      //   this.IsOptimoney = false;
      //   this.CompanyLogo = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,'
      // + sessionStorage.getItem('lkighty445dh=='));
    }
    // this.UserType = parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')));

    //this.UserType ='3';
  }
}
